/* PD product page (2026-10-04): right-hand panels, variant picking / add to cart and the "Explora la colección"
   row of sections/pd-product and pd-product-slider, ported from the pdpaola theme's assets/pd.js. Product cards and
   photo strips are handled by assets/pd-collection.js. Styles in assets/pd-product.css. */
(() => {
  if (window.__pdProduct) return;
  window.__pdProduct = true;
  const root = document.documentElement;
  const desktop = window.matchMedia('(min-width: 960px)');

  /* ───────────── Right-hand panels (size guide, shipping…) ───────────── */
  let drawersBound = false;
  function initDrawers() {
    document.querySelectorAll('[data-pd-drawer]').forEach((d) => {
      if (d.parentElement === document.body) return;
      const old = document.getElementById(d.id);
      if (old && old !== d && old.parentElement === document.body) old.remove();
      document.body.appendChild(d);
    });
    if (drawersBound) return;
    drawersBound = true;
    let opener = null;
    const close = (d) => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); root.classList.remove('pd-lock'); if (opener) opener.focus({ preventScroll: true }); };
    document.addEventListener('click', (e) => {
      const o = e.target.closest('[data-pd-drawer-open]');
      if (o) {
        const d = document.getElementById(o.dataset.pdDrawerOpen);
        if (!d) return;
        opener = o;
        d.classList.add('is-open');
        d.setAttribute('aria-hidden', 'false');
        root.classList.add('pd-lock');
        const c = d.querySelector('[data-pd-drawer-close]:not(.pd-drawer__veil)');
        if (c) setTimeout(() => c.focus({ preventScroll: true }), 50);
        return;
      }
      const c = e.target.closest('[data-pd-drawer-close]');
      if (c) close(c.closest('[data-pd-drawer]'));
    });
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const d = document.querySelector('[data-pd-drawer].is-open');
      if (d) close(d);
    });
  }

  /* ───────────── Product page (sections/pd-product) ───────────── */
  function initProduct() {
    document.querySelectorAll('[data-pd-product]:not([data-pd-ready])').forEach((el) => {
      el.dataset.pdReady = '1';
      let variants = [];
      try { variants = JSON.parse(el.querySelector('[data-pd-variants]').textContent); } catch (e) { return; }
      const idInput = el.querySelector('[data-pd-variant-id]');
      const start = variants.find((v) => String(v.id) === idInput.value) || variants[0];
      const groups = [...el.querySelectorAll('[data-pd-option]')];
      const selected = start ? start.options.slice() : [];
      groups.forEach((g) => {
        const i = Number(g.dataset.pdOption);
        const on = g.querySelector('[data-pd-value].is-selected');
        selected[i] = on ? on.dataset.pdValue : null;
      });
      const addBtn = el.querySelector('[data-pd-add-main]');
      const addLabel = el.querySelector('[data-pd-add-label]');
      const price = el.querySelector('[data-pd-price]');
      const subValue = el.querySelector('[data-pd-sub-value]');
      const track = el.querySelector('[data-pd-gallery]');
      const bar = el.querySelector('[data-pd-bar]');
      const headerH = () => parseFloat(getComputedStyle(root).getPropertyValue('--height-header')) || (desktop.matches ? 72 : 56);
      // wide screens: scroll the page to the photo; phones: turn the photo box to it (top to bottom since 2026-10-13)
      let turnTo = null;
      const toSlide = (slide) => {
        if (desktop.matches) window.scrollTo({ top: Math.max(0, slide.getBoundingClientRect().top + window.scrollY - headerH()), behavior: 'smooth' });
        else if (turnTo) turnTo(Array.prototype.indexOf.call(track.children, slide));
      };
      const sticky = el.querySelector('[data-pd-sticky]');
      const esc = (t) => String(t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

      const pendingGroup = () => groups.find((g) => selected[Number(g.dataset.pdOption)] == null);
      const match = () => variants.find((v) => v.options.every((o, i) => o === selected[i]));

      const update = (fromUser) => {
        // Values that can't be bought with the rest of the current choice turn grey.
        groups.forEach((g) => {
          const i = Number(g.dataset.pdOption);
          g.querySelectorAll('[data-pd-value]').forEach((b) => {
            const ok = variants.some((v) => v.available && v.options[i] === b.dataset.pdValue && v.options.every((o, k) => k === i || selected[k] == null || o === selected[k]));
            b.classList.toggle('is-unavailable', !ok);
            const on = selected[i] === b.dataset.pdValue;
            b.classList.toggle('is-selected', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
        const pend = pendingGroup();
        if (pend) {
          addBtn.disabled = false;
          addLabel.textContent = pend.dataset.pdOptionLabel || 'Seleccionar';
          return;
        }
        el.querySelectorAll('.pd-p__option.is-alert').forEach((g) => g.classList.remove('is-alert'));
        const v = match();
        if (!v) { addBtn.disabled = true; addLabel.textContent = 'No disponible'; return; }
        idInput.value = v.id;
        addBtn.disabled = !v.available;
        addLabel.textContent = v.available ? 'Añadir al carrito' : 'Agotado';
        if (price) price.innerHTML = (v.compare ? `<s>${esc(v.compare)}</s> ` : '') + esc(v.price);
        if (subValue) {
          const sw = groups.find((g) => g.classList.contains('pd-p__swatches'));
          if (sw) subValue.textContent = selected[Number(sw.dataset.pdOption)];
        }
        if (fromUser) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
          if (v.media && track) {
            const slide = track.querySelector(`[data-media-id="${v.media}"]`);
            if (slide) toSlide(slide);
          }
        }
      };

      el.addEventListener('click', (e) => {
        const b = e.target.closest('[data-pd-value]');
        if (!b || !el.contains(b)) return;
        const g = b.closest('[data-pd-option]');
        selected[Number(g.dataset.pdOption)] = b.dataset.pdValue;
        update(true);
      });

      const form = el.querySelector('[data-pd-form]');
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const pend = pendingGroup();
        if (pend) {
          pend.classList.remove('is-alert');
          void pend.offsetWidth;
          pend.classList.add('is-alert');
          if (!desktop.matches) pend.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (addBtn.disabled) return;
        const base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        addBtn.classList.add('is-busy');
        fetch(`${base}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] }) })
          .then((r) => { if (!r.ok) throw r; return fetch(`${base}cart.js`); })
          .then((r) => r.json())
          .then((cart) => {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            // theme.js opens the quick cart on this event
            if (window.gcQuickCart) document.dispatchEvent(new CustomEvent('gc:cart-added', { detail: { cart } }));
            else window.location.href = `${base}cart`;
          })
          .catch(() => form.submit())
          .finally(() => addBtn.classList.remove('is-busy'));
      });

      /* Photos on phones (2026-10-05, explicit request "mejor copia este estilo", pdpaola.com/products/rodeo-slider-necklace):
         a sideways strip (swiping is assets/pd-collection.js) with a progress line under it; this replaces the
         miumiu.com draggable sheet of earlier that day. The header is see-through while it is over the photos
         (2026-10-05, "header transparente en fotos de producto", phones only). */
      if (track) {
        const gallery = track.parentElement;
        const n = track.children.length;
        const dots = Array.from(el.querySelectorAll('[data-pd-dot]'));
        dots.forEach((dot, i) => dot.addEventListener('click', () => { if (track.children[i]) toSlide(track.children[i]); }));
        let queued = false;
        const mark = () => {
          queued = false;
          if (desktop.matches) { root.classList.remove('pd-hdr-clear'); return; }
          root.classList.toggle('pd-hdr-clear', gallery.getBoundingClientRect().bottom > headerH() + 1);
          if (dots.length) {
            // phones: the photos turn inside the box from top to bottom
            const h = track.clientHeight || 1;
            const at = Math.min(n - 1, Math.max(0, Math.round(track.scrollTop / h)));
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === at));
          }
          if (bar && n > 1) {
            const max = track.scrollWidth - track.clientWidth;
            const p = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 0;
            bar.style.transform = `translateX(${p * (n - 1) * 100}%)`;
          }
        };
        const queueMark = () => { if (!queued) { queued = true; requestAnimationFrame(mark); } };
        // Phones layout with a mouse (touch uses the browser's own snapping): one wheel notch or one drag turns exactly
        // one photo — a notch is shorter than half a photo, so the snapping alone would send it back. At the first /
        // last photo the wheel is left alone and the page scrolls on.
        const photoAt = () => Math.round(track.scrollTop / (track.clientHeight || 1));
        // the turn is animated here (the browser's own smooth scroll felt stiff): 750ms, quick start and a long soft landing
        let turnRaf = 0;
        const toPhoto = (i) => {
          const target = Math.min(n - 1, Math.max(0, i)) * track.clientHeight;
          const from = track.scrollTop;
          const dist = target - from;
          cancelAnimationFrame(turnRaf);
          if (Math.abs(dist) < 1) { track.style.scrollSnapType = ''; return; }
          track.style.scrollSnapType = 'none';
          const t0 = performance.now();
          const tick = (now) => {
            const k = Math.min(1, (now - t0) / 750);
            track.scrollTop = from + dist * (1 - Math.pow(1 - k, 4));
            if (k < 1) { turnRaf = requestAnimationFrame(tick); return; }
            track.scrollTop = target;
            track.style.scrollSnapType = '';
          };
          turnRaf = requestAnimationFrame(tick);
        };
        turnTo = toPhoto;
        let wheelLock = 0;
        track.addEventListener('wheel', (e) => {
          if (desktop.matches || !e.deltaY || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
          const target = photoAt() + (e.deltaY > 0 ? 1 : -1);
          const busy = Date.now() < wheelLock;
          if (!busy && (target < 0 || target > n - 1)) return;
          e.preventDefault();
          if (busy) return;
          wheelLock = Date.now() + 420;
          toPhoto(target);
        }, { passive: false });
        let dragY = 0, dragTop = 0, dragAt = 0, dragOn = false, dragMoved = false;
        track.addEventListener('mousedown', (e) => {
          if (desktop.matches || e.button !== 0) return;
          dragOn = true; dragMoved = false; dragY = e.clientY; dragTop = track.scrollTop; dragAt = photoAt();
        });
        window.addEventListener('mousemove', (e) => {
          if (!dragOn) return;
          const dy = e.clientY - dragY;
          if (!dragMoved && Math.abs(dy) < 5) return;
          dragMoved = true;
          track.style.scrollSnapType = 'none';
          track.scrollTop = dragTop - dy;
        });
        window.addEventListener('mouseup', (e) => {
          if (!dragOn) return;
          dragOn = false;
          if (!dragMoved) return;
          const dy = e.clientY - dragY;
          toPhoto(dragAt + (Math.abs(dy) > 40 ? (dy < 0 ? 1 : -1) : 0));
        });
        // the line follows the finger; mark() also runs straight away in case the browser holds animation frames
        track.addEventListener('scroll', () => { mark(); }, { passive: true });
        window.addEventListener('scroll', () => { mark(); }, { passive: true });
        window.addEventListener('resize', queueMark);
        desktop.addEventListener('change', queueMark);
        mark();
      }

      // A details column taller than the screen sticks by its bottom instead of its top.
      if (sticky && 'ResizeObserver' in window) {
        const fit = () => {
          const h = sticky.offsetHeight;
          const head = parseFloat(getComputedStyle(root).getPropertyValue('--height-header')) || 72;
          sticky.style.top = (h + head + 50 > window.innerHeight) ? `${Math.round(window.innerHeight - h - 30)}px` : '';
        };
        new ResizeObserver(fit).observe(sticky);
        window.addEventListener('resize', fit);
      }

      update(false);
    });
  }

  /* ───────────── "Explora la colección" row (sections/pd-product-slider) ───────────── */
  function initRelated() {
    document.querySelectorAll('[data-pd-rel]:not([data-pd-ready])').forEach((rel) => {
      rel.dataset.pdReady = '1';
      const track = rel.querySelector('[data-pd-rel-track]');
      const prev = rel.querySelector('[data-pd-rel-prev]');
      const next = rel.querySelector('[data-pd-rel-next]');
      const bar = rel.querySelector('[data-pd-rel-progress]');
      const thumb = rel.querySelector('[data-pd-rel-thumb]');
      if (!track) return;
      const step = () => { const item = track.firstElementChild; return item ? item.offsetWidth : track.clientWidth; };
      const sync = () => {
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 4;
        // progress bar: the thumb is as wide as the visible share of the row and travels with the scroll
        if (bar && thumb) {
          const max = track.scrollWidth - track.clientWidth;
          bar.hidden = max < 4;
          if (max >= 4) {
            const share = track.clientWidth / track.scrollWidth;
            thumb.style.width = (share * 100) + '%';
            thumb.style.transform = 'translateX(' + ((track.scrollLeft / max) * (1 - share) / share * 100) + '%)';
          }
        }
      };
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      // drag with the mouse (touch keeps the native scroll): the row follows the pointer 1:1, keeps the speed of
      // the throw when released and eases to a stop on a card edge; a drag does not open the card under the pointer
      let startX = 0, startLeft = 0, down = false, moved = false, lastX = 0, lastT = 0, speed = 0, raf = 0;
      const stopGlide = () => { if (raf) { cancelAnimationFrame(raf); raf = 0; } };
      const glideTo = (target) => {
        const from = track.scrollLeft;
        const dist = target - from;
        if (Math.abs(dist) < 1) { track.classList.remove('is-free'); return; }
        const time = Math.min(1100, Math.max(450, Math.abs(dist) * 1.6));
        const t0 = performance.now();
        const tick = (now) => {
          const p = Math.min(1, (now - t0) / time);
          track.scrollLeft = from + dist * (1 - Math.pow(1 - p, 4));
          if (p < 1) { raf = requestAnimationFrame(tick); return; }
          raf = 0;
          track.scrollLeft = target;
          track.classList.remove('is-free');
        };
        raf = requestAnimationFrame(tick);
      };
      track.classList.add('is-draggable');
      track.addEventListener('mousedown', (e) => {
        if (e.button !== 0) return;
        stopGlide();
        down = true; moved = false; speed = 0;
        startX = lastX = e.pageX; lastT = performance.now(); startLeft = track.scrollLeft;
      });
      window.addEventListener('mousemove', (e) => {
        if (!down) return;
        const dx = e.pageX - startX;
        if (!moved && Math.abs(dx) < 5) return;
        if (!moved) { moved = true; track.classList.add('is-free', 'is-dragging'); }
        const now = performance.now();
        if (now > lastT) speed = speed * 0.6 + ((lastX - e.pageX) / (now - lastT)) * 0.4;
        lastX = e.pageX; lastT = now;
        track.scrollLeft = startLeft - dx;
      });
      window.addEventListener('mouseup', () => {
        if (!down) return;
        down = false;
        if (!moved) return;
        track.classList.remove('is-dragging');
        if (performance.now() - lastT > 80) speed = 0;
        const max = track.scrollWidth - track.clientWidth;
        const w = step();
        let target = Math.round((track.scrollLeft + speed * 320) / w) * w;
        if (target > max - w / 2) target = max;
        glideTo(Math.max(0, Math.min(max, target)));
      });
      track.addEventListener('wheel', () => { if (raf) { stopGlide(); track.classList.remove('is-free'); } }, { passive: true });
      track.addEventListener('dragstart', (e) => e.preventDefault());
      track.addEventListener('click', (e) => {
        if (!moved) return;
        moved = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    });
  }

  const init = () => { initDrawers(); initProduct(); initRelated(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
